import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

/**
 * Orientation is locked to portrait on every platform, desktop included
 * (§12.3). Where the API isn't available we fall back to the CSS overlay in
 * styles.css rather than reflowing, because nothing in this design reflows.
 */
const orientation = screen.orientation as ScreenOrientation & {
  lock?: (o: string) => Promise<void>;
};
orientation?.lock?.('portrait').catch(() => {
  /* Unsupported on desktop and iOS Safari; the CSS fallback covers it. */
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
